import React from 'react';
import { Box, Button, ToggleButtonGroup } from '@spothero/ui';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMobileListView } from 'store/search/search-actions';
export default function MobileToggle({ onViewToggle }) {
    const dispatch = useDispatch();
    const isMobileListViewActive = useSelector((state) => state.search.data.isMobileListViewActive);
    const toggleValue = isMobileListViewActive ? 'mobile-list' : 'mobile-map';
    const handleClick = () => {
        if (!isMobileListViewActive) {
            // When switching back to list view we do a full page reload
            // to show the original search results
            // Slack: https://spothero.slack.com/archives/C025ELN6L2G/p1704485541060059?thread_ts=1704482935.260369&cid=C025ELN6L2G
            return window.location.reload();
        }
        if (onViewToggle)
            onViewToggle(!isMobileListViewActive);
        dispatch(toggleMobileListView(!isMobileListViewActive));
    };
    return (<Box sx={{
            '& button': {
                paddingY: '6px',
            },
        }}>
            <ToggleButtonGroup onChange={handleClick} value={toggleValue}>
                <Button key="mobile-list" value="mobile-list" fontSize="sm">
                    List
                </Button>
                <Button key="mobile-map" value="mobile-map" fontSize="sm">
                    Map
                </Button>
            </ToggleButtonGroup>
        </Box>);
}
